import React from 'react';
import { Link } from 'react-router-dom';
import Container from '../common/Container';
import { Logo } from '../common/Logo';

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
      <Container>
        <div className="flex flex-col items-center justify-left py-6">
          <div className="flex flex-wrap justify-center gap-6 mb-2">
            <Link to="/" className="text-sm/6 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">Home</Link>
            <Link to="/employers" className="text-sm/6 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">Showcase Your Culture</Link>
            <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-sm/6 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">Terms of Service</a>
            <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-sm/6 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">Privacy Policy</a>
          </div>
          <div className="text-sm/6 text-gray-600 dark:text-gray-300">
            &copy; {new Date().getFullYear()} Burnt Inc.
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;